import React from "react";
import { useTranslation } from "react-i18next";
import { Body2, CloseCircleIcon, Button, CheckboxBlankTogglerIcon, SkeletonLoader } from "@activecollab/components";
import PropTypes from "prop-types";
import { stringifyUrl } from "query-string";
import PublicInvoicePaymentResolver from "~/components/InvoiceObject/PublicInvoicePaymentResolver";
import Angie from "~/utils/angie";

export const PublicInvoiceStatus = ({ data, isLoading, eInvoice }) => {
  const { t } = useTranslation();
  const number = data?.invoice?.number;
  const hash = data?.invoice?.hash;
  const status = data?.invoice?.status;
  return (
    <div className="tw-bg-theme-200 tw-flex tw-flex-col tw-gap-4 md:tw-flex-row tw-justify-between tw-py-3 tw-px-8 tw-items-center">
      {isLoading ? (
        <>
          <SkeletonLoader className="tw-w-44" />
          <SkeletonLoader className="tw-w-32" />
        </>
      ) : (
        <>
          <div className="tw-flex tw-gap-2 tw-items-center">
            {status === "canceled" ? <CloseCircleIcon fill="var(--red-alert)" /> : null}
            {status === "paid" ? <CheckboxBlankTogglerIcon fill="var(--color-sucess-green)" /> : null}
            <Body2
              weight="bold"
              color={status === "canceled" ? "alert" : status === "paid" ? "success" : "primary"}
            >
              {status === "canceled"
                ? t("This invoice is canceled.")
                : status === "paid"
                ? t("This invoice is paid in full.")
                : `${t("Left to Pay")}: ${data?.invoice?.balance_due} ${data?.currency?.code}`}
            </Body2>
            <PublicInvoicePaymentResolver data={data} />
          </div>
          <div className="tw-flex tw-gap-3">
            <a
              href={stringifyUrl({
                url: `${Angie.api_url}/s/invoice`,
                query: { number, hash, download: 1 },
              })}
            >
              <Button variant={data?.enable_payment ? "secondary" : "primary"}>{t("Download PDF")}</Button>
            </a>
            {eInvoice ? (
              <a
                href={stringifyUrl({
                  url: `${Angie.api_url}/s/einvoice`,
                  query: { number, hash, download: 1 },
                })}
              >
                <Button variant="secondary">{t("Download eInvoice")}</Button>
              </a>
            ) : null}
          </div>
        </>
      )}
    </div>
  );
};

PublicInvoiceStatus.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  eInvoice: PropTypes.bool,
};

export default PublicInvoiceStatus;
